// extracted by mini-css-extract-plugin
export default {"express_checkout":"nr","buttons":"or","stripe":"pr","or_title":"qr","line":"rr","express_checkout_title":"sr","center_block":"tr"};
    if(module.hot) {
      // 1713969925845
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  